module.exports = __webpack_public_path__ + "media/images/category/rank4-d69d4e8175c1cf7c68fe9203e883c16c.gif";